// extracted by mini-css-extract-plugin
export default {"image":"Y1-z","loaded":"Z1-z"};